var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ez-toggle"},[_c('button',{class:{
      'ez-toggle__button': true,
      'ez-toggle__button--active': _vm.state,
      'ez-toggle__button--disabled': _vm.disabled,
    },attrs:{"type":"button","data-cy":_vm.dataCy,"disabled":_vm.disabled},on:{"click":_vm.toggleState}},[(_vm.state)?_c('span',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._t("active",function(){return [_vm._v("Active")]})],2):_vm._t("inactive",function(){return [_vm._v("Inactive")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }